module.exports = __webpack_public_path__ + "static/img/par7.5f99c78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par7.png
// module id = /vyz
// module chunks = 0